import React, { Component } from "react";
import { Link, withRouter,  } from "react-router-dom";
import HowToBuySection from "../../modules/HowToBuySection";
import MainProsSection from "../../modules/MainProsSection";
import CharacteristicFeaturesList from "../../modules/CharacteristicFeaturesList";
import ContactFormDetails from "../../modules/ContactFormDetailsSection";
import { Box, Button, Icon, Tag, Text, Media, Illustration } from "@mbank-design/design-system/components";
import VehicleGallery from "../../modules/VehicleGallery";
import MainContactSection from "../../modules/MainContactSection";
import {
  Car,
  FuelPump,
  Gearbox,
  Engine,
  Leaf,
  InfoRound
} from "@mbank-design/design-system/icons";
import "./index.scss";
import CarDetailsInformationTile from "../../parts/CarDetailsInformationTile";
import { LoadingSpinner } from "../../parts/LoadingSpinner";
import {
  getLeaseDetailsData,
  getNewDetailsData,
  getAuctionsDetailsData,
  getSimplifiedVehicleData,
  getFavoriteAllVehicles,
  getAttractivenessLevels
} from "../../../services";
import SectionTitleComponent from "../../modules/SectionTitleComponent";
import CarOfferTile from "../../modules/CarOfferTile";
import CarsSection from "../../modules/CarsSection";
import {
  getRecommendedAfterLeaseVehicles,
  getRecommendedNewVehicles
} from "../../../services/index";
import { MobileSearchContext, ToastContext } from "../../../scripts/commons/contexts";
import { Stack } from "@mbank-design/design-system/components/Stack/Stack";
import uuid from "react-uuid";
import { literalCreator } from "../../../literals/literals";
import PromotedOfferSticker from "../../parts/PromotedOfferSticker";
import * as moment from "moment";
import "moment/locale/pl";
import { clearEmptyCampaignData, setCampaignData } from "../../common/campaign-data-setter";
import { endpointGuard } from "../../../scripts/commons/guard/endpoint-guard";
import DetailsPageHelmet from "../../parts/DetailsPageHelmet";
import { SeoCarSchema } from "../../parts/SeoCarSchema";
import { SeoBreadcrumbListSchema } from "../../parts/SeoBreadcrumbListSchema";
import { newTileLinkCreator } from "../../../services/newTileLinkCreator";
import {
  cutIdFromMathParams,
  imitationClickForCloseAllTooltips,
  replaceSpecialCharsets
} from "../../../scripts/commons/common";
import { isWebpSupported as webpSupported } from "../../../scripts/commons/support-webp";
import { ManDreamSavingGoalsMass } from "@mbank-design/design-system/illustrations";
import MobileMainPageSearch from "../../modules/MobileMainPageSearch";
import DetailWhyUs from "../../parts/DetailWhyUs";
import Breadcrumbs from "../../parts/Breadcrumbs";
import EquipmentList from "../../modules/EquipmentList";
import DetailNavigationContainer from "../../parts/DetailNavigationContainer";
import { DetailsCertificateWidget } from "../../parts/DetailsCertificateWidget";
import DetailsNavigation from "../../parts/DetailsNavigation";
import CarsCarousel from "../../parts/CarsCarousel";
import ButtonCopyLink from "../../parts/ButtonCopyLink";
import ButtonFavorite from "../../parts/ButtonFavorite";
import SpecialPromotions from "../../parts/SpecialPromotions";
import FavouriteButton from "../../modules/FavouriteButton";
import { ContactModal } from "../../modules/ContactModal";
import { cleanupCalculatorSession } from "../../modules/CalculatorRework/utils/cleanupCalculatorSession";
import { DetailsPageCalculatorAdditionalPackagesConnected } from "../../modules/CalculatorRework/DetailsPageCalculatorAdditionalPackages";
import { DetailsPageCalculatorMobileConnected } from "../../modules/CalculatorRework/DetailsPageCalculatorMobile";
import {
  FontColor,
  FontSize,
  FontWeight,
  LineHeight
} from "@mbank-design/design-system/design-tokens/general/typography";
import { Direction, IconColor, IllustrationSize } from "@mbank-design/design-system/enums";
import seoModels from "./seoModels";
import AwardBanner from "../../modules/AwardBanner";
import PromoBanner from "../../parts/PromoBanner";
import { CarAcquisitionSection } from "../../parts/CarAcquisitionSection";
import PromoBannerForAll from "../../parts/PromoBannerForAll";
import PromoBannerMB from "../../parts/PromoBannerMB";
import { CalculatorRework } from "../../modules/CalculatorRework";
import { DetailsCalculatorBridge } from "../../modules/CalculatorRework/DetailsCalculatorBridge";

moment.locale("en");

function detailsPathSegment(pageType) {
  switch (pageType) {
    case "new":
      return "nowe-samochody";
    case "afterLease":
      return "samochody-poleasingowe";
    case "auction":
      return "aukcje-samochodowe";
    default:
      return "nowe-samochody";
  }
}

function buildSeoCarData(details, pageType, rawParamId) {
  const id = cutIdFromMathParams(rawParamId);
  const slug = `${detailsPathSegment(pageType)}/${newTileLinkCreator(details.Make, details.Model, id)}`;
  const title = [details.Make, details.Model, details.Type && replaceSpecialCharsets(details.Type)]
    .filter(Boolean)
    .join(" ");
  const price =
    details.TotalPriceBrutto != null && details.TotalPriceBrutto !== ""
      ? Number(details.TotalPriceBrutto)
      : details.TotalPriceNetto != null && details.TotalPriceNetto !== ""
        ? Number(details.TotalPriceNetto)
        : 0;
  const year = parseInt(String(details.Year), 10) || new Date().getFullYear();
  const images = Array.isArray(details.Photos) ? details.Photos.filter(Boolean) : [];
  const mileage = Number(details.Mileage) || 0;
  const doors = details.DoorsCount || details.DoorsNumber;
  const seats = details.SeatsCount || details.SeatsNumber;

  return {
    slug,
    title,
    brand: details.Make,
    model: details.Model,
    year,
    vin: details.VIN || undefined,
    price,
    currency: "PLN",
    availability: details.Reservation
      ? "https://schema.org/OutOfStock"
      : "https://schema.org/InStock",
    condition:
      pageType === "new" ? "https://schema.org/NewCondition" : "https://schema.org/UsedCondition",
    mileage,
    mileageUnit: "KMT",
    image: images,
    color: details.Color || undefined,
    bodyType: details.BodyType || undefined,
    trim: details.Type ? replaceSpecialCharsets(details.Type) : undefined,
    fuelType: details.FuelTypeFullName || details.FuelType || undefined,
    transmission: details.GearBoxType || undefined,
    doors: doors ? Number(doors) : undefined,
    seats: seats ? Number(seats) : undefined
  };
}

const charListRef = React.createRef();

// visually hidden (screen readers / SEO) - used to keep car version in H1 without changing the layout
const SEO_HIDDEN_STYLE = { position: "absolute", width: 1, height: 1, margin: -1, padding: 0, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0 };

class DetailsPage extends Component {
  state = {
    auctionId: parseInt(cutIdFromMathParams(this.props.match.params.id)),
    details: null,
    calculatorTabSelected: 1,
    calculatorSnapshot: null,
    attractivenessLevel: null,
    attractivenessLevels: null,
    attractivenessLevelsProvisions: null,
    technicalInformationList: [],
    paramsValue: "",
    backgroundPhoto: "",
    pageType: "",
    currentlySelectedVariant: 0,
    currentlySelectedRecommendedVehicle: 0,
    isCompany: true,
    recommendedCars: [],
    contactUrl: null,
    showLoader: false,
    favouriteCarData: {},
    isContactModalOpen: false,
    urlObject: "",
    isShowSlider: false,
    modalButtonData:{},
    urlToContactSection:'',
    toggleRetailModalForm: false,
    templateId:null,
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    const queryParams = new URLSearchParams(this.props.location.search);
    const templateId = queryParams.get("atrTemplateId");
    const vendorType = queryParams.get("vendorType");
    const login = queryParams.get("login");
    templateId && this.setState({templateId:templateId, vendorType:vendorType, login:login})
    literalCreator.getLiterals().then((res) => {
      this.setState({ literals: literalCreator.data }, () => {
        this.setState({ showLoader: false });
        window.scrollTo(0, 0);
        this.initDetails();
      });
    });
    clearEmptyCampaignData()
    // setCampaignData();
    if (document.getElementById("root")) {
      document.getElementById("root").scrollTop = 0;
    }
  }
  getFavouriteCarData = () => {
    getFavoriteAllVehicles({
      IdArr: [this.state.auctionId]
    }).then((res) => {
      let favouriteCarData;
      if (this.state.pageType === "afterLease") {
        favouriteCarData = res.data.AfterLease[0];
      } else if (this.state.pageType === "new") {
        favouriteCarData = res.data.NewVehicles[0];
      }
      this.setState({ favouriteCarData });
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      cleanupCalculatorSession();
      this.initDetails();
    }
  }

  initDetails() {
    localStorage.setItem("previousViewedCarId", cutIdFromMathParams(this.props.match.params.id));
  
    let pageType = "";
    const pathName = this.props.match.path.split("/")[1];
    
    if (pathName === "nowe-samochody") {
      pageType = "new";
    } else if (pathName === "samochody-poleasingowe") {
      pageType = "afterLease";
    }
  
    this.setState({
      isLoading: true,
      calculatorSnapshot: null,
      calculatorTabSelected: 1,
      details: null,
      pageType: pageType
    }, this.fetchAllData);
  }
  
  async fetchAllData() {
    try {
      await this.getCarData();
      await this.getRecommendedVehicles();
      await this.getFavouriteCarData();
      await this.initAttractivenessLevels();
      
      this.setState({ isLoading: false });
    } catch (error) {
      console.error('Error fetching data:', error);
      this.setState({ 
        isLoading: false,
        error: 'Failed to load data'
      });
    }
  }
  
  componentWillUnmount() {
    this.props.setDarkTheme && this.props.setDarkTheme(false);
    cleanupCalculatorSession();
  }

  async getRecommendedVehicles() {
    let vehiclesArray = [];
    // new
    if (this.state.pageType === "new") {
      await getRecommendedNewVehicles(cutIdFromMathParams(this.props.match.params.id)).then((response) => {
        vehiclesArray = Object.values(response.data);
        this.setState({
          recommendedCars: vehiclesArray.filter((vehicle) => vehicle.AuctionId !== 0)
        });
      });
    }

    // after lease
    if (this.state.pageType === "afterLease") {
      getRecommendedAfterLeaseVehicles(cutIdFromMathParams(this.props.match.params.id)).then((response) => {
        vehiclesArray = Object.values(response.data);
        this.setState({
          ...this.setState,
          recommendedCars: vehiclesArray.filter((vehicle) => vehicle.AuctionId !== 0)
        });
      });
    }
  }

  async getCarData() {
    if (this.props.match.url.includes("/new")) {
      await this.renderUrlFromSimplifiedDetails("new");
    } else if (this.props.match.url.includes("/afterLease")) {
      await this.renderUrlFromSimplifiedDetails("afterLease");
    } else if (this.props.match.url.includes("/auction")) {
      await this.renderUrlFromSimplifiedDetails("auction");
    }
    this.replaceWrongSymbolsFromUrl();

    // after lease
    if (this.state.pageType === "afterLease") {
      getLeaseDetailsData({
        id: cutIdFromMathParams(this.props.match.params.id)
      })
        .then((res) => {
          this.setLocalStorageHistory(res);

          this.setState(
            {
              ...this.state,
              details: [
                {
                  ...res.data
                }
              ]
            },
            () => {
              localStorage.removeItem("isCompany");
              this.fillTechnicalInformationsList();
            }
          );
        })
        .catch(() => {
          window.location.href = "/404";
        });
    }

    // new
    if (this.state.pageType === "new") {
      await getNewDetailsData({
        id: cutIdFromMathParams(this.props.match.params.id)
      })
        .then(async (res) => {
          this.setLocalStorageHistory(res);
          if (res.status >= 200 && res.status <= 299) {
            const details = res.data;

            this.setState(
              {
                ...this.state,
                details: [
                  {
                    ...details
                  }
                ]
              },
              () => {
                this.fillTechnicalInformationsList();
              }
            );
          } else {
            endpointGuard(res.data.ErrorCode);
          }
        })
        .catch(() => {
          window.location.href = "/404";
        });
    }
  }

  characteristicItemHandler(arrayOfStrings) {
    // replace array of Strings with obj {label: string, url: string}
    // we're using it inside characteristicFeaturesList
    let arr = [];
    if (arrayOfStrings && arrayOfStrings.length) {
      for (let item of arrayOfStrings) {
        arr.push({ label: item });
      }
    }
    return arr;
  }

  replaceWrongSymbolsFromUrl() {
    if (this.props.match.params.id !== this.props.match.params.id.toLowerCase()) {
      this.props.history.push(this.props.location.pathname.toLowerCase() + this.props.location.search);
    }

    if (this.props.match.params.id.includes("_")) {
      this.props.history.push(this.props.match.url.replaceAll("_", "-"));
    } else if (
      this.props.match.params.id.lastIndexOf("-id-") > 0 &&
      !this.props.match.params.id.substring(0, this.props.match.params.id.lastIndexOf("-id-")).includes("-")
    ) {
      window.location.href = "/404";
    }
  }

  async renderUrlFromSimplifiedDetails(type) {
    if (isNaN(parseInt(this.props.match.params.id))) {
      this.props.history.push("/nowe-samochody/" + this.props.match.params.id + this.props.location.search);
    } else {
      const oldPathName = this.props.match.path.split("/")[1];
      let pathName = "nowe-samochody";
      switch (oldPathName) {
        case "new":
          pathName = "nowe-samochody";
          break;
        case "afterLease":
          pathName = "samochody-poleasingowe";
          break;
        case "auction":
          pathName = "aukcje-samochodowe";
          break;
        default:
          pathName = "nowe-samochody";
          break;
      }
      await getSimplifiedVehicleData(this.props.match.params.id, type)
        .then(async (res) => {
          let link = "/" + pathName + "/" + res.data.Make + "-" + res.data.Model + "-id-" + this.props.match.params.id;
          this.props.history.push(`${link}${this.props.location.search}`);
        })
        .catch(() => {
          window.location.href = "/" + pathName;
        });
    }
  }

  fillTechnicalInformationsList() {
    if (!this.state.details) return;

    let list = [];
    const details = this.state.details[this.state.currentlySelectedVariant];
    const isElectric = details.IsElectric;
    list.push({
      label: `marka: ${details.Make}`,
      url: "marki/" + details.Make
    });
    list.push({
      label: `model: ${details.Model}`,
      url: `marki/${details.Make}-${details.Model}`
    });
    list.push({
      label: `typ: ${replaceSpecialCharsets(details.Type)}`,
      url: null
    });
    list.push({
      label: `rok: ${details.Year}`,
      url: null
    });
    if (this.state.pageType !== "new") {
      list.push({
        label: `przebieg: ${details.Mileage} km`,
        url: null
      });
    }
    list.push({
      label: `rodzaj paliwa: ${isElectric ? `samochód elektryczny` : details.FuelTypeFullName.toLowerCase()}`,
      url: isElectric ? `samochody-elektryczne` : null
    });
    if (this.state.pageType !== "new") {
      list.push({
        label: `VIN: ${details.VIN}`,
        url: null
      });
    }
    details.EngineCapacity &&
      list.push({
        label: `${isElectric ? "pojemność akumulatora" : "pojemność"}: ${details.Capacity || details.EngineCapacity} ${
          isElectric ? "kWh" : "cm3"
        }`,
        url: null
      });

    if (isElectric && details?.VehicleRange) {
      list.push({
        label: `zasięg: ${details.VehicleRange} km`,
        url: null
      });
    }

    if (details?.Wltp) {
      list.push({
        label: `zużycie prądu (wltp): ${details.Wltp}`,
        url: null
      });
    }

    list.push({
      label: `moc (KM): ${details.HP || details.PowerHP}`,
      url: null
    });
    list.push({
      label: `moc (kW): ${details.KW || details.PowerKW}`,
      url: null
    });
    list.push({
      label: `liczba drzwi: ${details.DoorsCount || details.DoorsNumber}`,
      url: null
    });
    list.push({
      label: `liczba siedzeń: ${details.SeatsCount || details.SeatsNumber}`,
      url: null
    });
    if (details.BodyType) {
      list.push({
        label: `typ nadwozia: ${details.BodyType}`,
        url: details.BodyType
      });
    }
    list.push({
      label: `kolor: ${details.Color.toLowerCase()}`,
      url: null
    });
    if (details.ColorInterior) {
      list.push({
        label: `kolor tapicerki: ${details.ColorInterior.toLowerCase()}`,
        url: null
      });
    }
    if (details.FuelConsumptionTotal && !isElectric) {
      list.push({
        label: `spalanie w cyklu miejskim: ${details.FuelConsumptionTotal}`,
        url: null
      });
    }
    if (details.FuelConsumptionOutOfTownCycle && !isElectric) {
      list.push({
        label: `spalanie w cyklu pozamiejskim: ${details.FuelConsumptionOutOfTownCycle}`,
        url: null
      });
    }
    if (details.FuelConsumptionMixedCycle && !isElectric) {
      list.push({
        label: `spalanie w cyklu mieszanym: ${details.FuelConsumptionMixedCycle}`,
        url: null
      });
    }
    if (this.state.pageType === "afterLease") {
      list.push({
        label: `kategoria: ${"samochody poleasingowe"}`,
        url: "samochody-poleasingowe"
      });
    }
    if (this.state.pageType === "new") {
      list.push({
        label: `kategoria: ${"nowe samochody"}`,
        url: "nowe-samochody"
      });
    }
    if (this.state.pageType === "new") {
      list.push({
        label: `numer referencyjny: ${details.ReferenceNumber}`,
        url: null
      });
    }
    if (this.state.pageType === "new" && details.Co2Emission && !isElectric) {
      list.push({
        label: `emisja co2: ${details.Co2Emission}`,
        url: null
      });
    }
    this.setState({ technicalInformationList: list });
  }

  returnToPreviousPage() {
    if (this.props.history.length === 1) {
      this.props.history.push("/lista-pojazdow");
    } else {
      this.props.history.go(-1);
    }
  }

  scrollToCharacteristicList() {
    charListRef.current.scrollIntoView();
  }

  setBackgroundImage(pic) {
    this.setState({ backgroundPhoto: pic });
  }

  setRecommendedVehicleActive(index) {
    if (index >= 0 && index < this.state.recommendedCars.length)
      this.setState({
        currentlySelectedRecommendedVehicle: index
      });
  }

  changeDocumentBodyOverflow(hideOverflow) {
    let root = document.getElementById("root");
    if (root) {
      root.style.overflowY = hideOverflow ? "hidden" : "unset";
    }
  }

  getCorrectEquipment(details) {
    if (details == null) {
      return [];
    } else {
      if (details.Equipment && details.Equipment.length) {
        return this.characteristicItemHandler(details.Equipment);
      } else if (details.EquipmentStandard && details.EquipmentStandard.length) {
        return this.characteristicItemHandler(details.EquipmentStandard);
      } else {
        return [];
      }
    }
  }

  handleCarouselOnChange() {
    imitationClickForCloseAllTooltips();
  }

  setLocalStorageHistory = (vehicleRequestData) => {
    const historyData = JSON.parse(localStorage.getItem("viewHistory")) || [];
    if (historyData && historyData.length < 15) {
      historyData.push({
        vehicle: `${vehicleRequestData.data.Make} ${vehicleRequestData.data.Model}`,
        link: window.location.pathname
      });
    } else if (historyData.length >= 15) {
      historyData.shift();
      historyData.push({
        vehicle: `${vehicleRequestData.data.Make} ${vehicleRequestData.data.Model}`,
        link: window.location.pathname
      });
    }
    localStorage.setItem("viewHistory", JSON.stringify(historyData));
  };

  setUrlDataFromCalc = (urlString) => {
    this.setState({ urlObject: urlString });
  };

  setContactUrl = (url) => {
    this.setState({ contactUrl: url });
  };

  setCalculatorTabSelected = (tab) => {
    this.setState({ calculatorTabSelected: tab });
  };

  handleCalculatorSnapshot = (snapshot) => {
    this.setState({
      calculatorSnapshot: snapshot,
      calcCurrentPrices: {
        purePrice: snapshot.installmentPriceWithoutPackages,
        totalPrice: snapshot.installmentPrice
      }
    });
  };

  handleClickCalc = () => {
    if (document.querySelector(".floating-wrapper")) {
      document.querySelector(".floating-wrapper").style.display = "block";
      this.changeDocumentBodyOverflow(true);
    }
    if (document.querySelector(".reservation-info-container")) {
      document.querySelector(".reservation-info-container").style.dispaly = "none";
    }
    if (document.querySelector(".calculator-container")) {
      document.querySelector(".calculator-container").style.display = "block";
    }
  };

  async initAttractivenessLevels() {
    if (!this.state.templateId) return;
    try {
      const attractivenessLevels = await getAttractivenessLevels(
        this.state.templateId,
        this.state.vendorType,
        this.state.login
      );

      const selectStructureForLevels = [
        { label: "nie wybrano", value: "0" },
        ...(attractivenessLevels &&
          attractivenessLevels.data &&
          attractivenessLevels.data.map((item) => {
            return { label: item.Value, value: item.Value };
          }))
      ];
      const attractivenessLevelsProvisions =
        attractivenessLevels &&
        attractivenessLevels.data &&
        attractivenessLevels.data.map((item) => {
          return { level: item.Value, value: item.Text };
        });
      this.setState({
        attractivenessLevels: selectStructureForLevels,
        availableAttracivenessLevels: selectStructureForLevels,
        attractivenessLevelsProvisions: attractivenessLevelsProvisions
      });
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alert("Błąd przy wykonywaniu zapytania :" + error.response.data.ErrorMessage);
      }
    }
  }

  handelInterestLevelChange = (value) => {
    const provision =
      this.state.attractivenessLevelsProvisions &&
      this.state.attractivenessLevelsProvisions.find((el) => el.level === value);
    this.setState({
      attractivenessLevel: value,
      currentProvision: value === "0" ? null : provision?.value
    });
  };

  checkIfShownSlider = (isShowSlider) => {
    this.setState({ isShowSlider: isShowSlider });
  };

  handleContactModal = (data) => {
    this.setState({ isContactModalOpen: !this.state.isContactModalOpen });
    data && this.setUrlDataFromCalc(data);
  };

  setToggleRetailModalForm = () => {
    this.setState({
      toggleRetailModalForm:true
    })
   }

   handleCloseRequestModal = () => {
    this.setState({
      toggleRetailModalForm:false
    })
   }

  render() {
    let data = this.state;
    let details = this.state.details ? this.state.details[this.state.currentlySelectedVariant] : null;
    let chips = details && details.MarketingLabels ? JSON.parse(details.MarketingLabels) : null;
    const equipment = this.getCorrectEquipment(details);
    const equipmentAdditional =
      (details && details.EquipmentAdditional && this.characteristicItemHandler(details.EquipmentAdditional)) || [];
    const isWebpSupported = webpSupported();
    const isProgramMyElectric = details?.MyElectric;
    const isNewVehicle = this.state.pageType === "new";
    const isAfterLease = this.state.pageType === "afterLease";
    const seoModelName=`${details?.Make.toLowerCase()}_${details?.Model.toLowerCase()}`
    const modelNameForHeaders=`${details?.Make} ${details?.Model} `
    const isSeoModel = !!seoModels[seoModelName];
    const calculatorBridgeProps = details ? {
      carId: details.AuctionId,
      pageType: this.state.pageType,
      literals: this.state.literals,
      reservation: details.Reservation,
      availableAttracivenessLevels: this.state.availableAttracivenessLevels,
      currentLevel: this.state.attractivenessLevel,
      currentProvision: this.state.currentProvision,
      levelChangeHandler: this.handelInterestLevelChange,
      handleContactModal: this.handleContactModal,
      contactUrl: this.setContactUrl,
      setToggleRetailModalForm: this.setToggleRetailModalForm,
      disableApplication: details.DisableApplication,
      isProgramMyElectric: isProgramMyElectric,
      isLeasingAvailable: details.IsLeasingAvailable,
      isRentAvailable: details.IsRentAvailable,
      isCashAvailable: details.IsCashAvailable,
      isElectric: details.IsElectric,
      totalPriceNetto: details.TotalPriceNetto,
      totalPriceBrutto: details.TotalPriceBrutto,
      attractivenessLevel: this.state.attractivenessLevel,
      templateId: this.state.templateId,
      vendorType: this.state.vendorType,
      login: this.state.login,
      onActiveTabChange: this.setCalculatorTabSelected,
      onCalculatorSnapshot: this.handleCalculatorSnapshot
    } : null;

    // only one H1 on the page: desktop or mobile title (the other one is hidden by CSS and rendered as H2)
    const isDesktopView = typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia("(min-width: 1024px)").matches
      : true;
    const seoTitleVersion = details ? replaceSpecialCharsets(details.Type) : "";

    return (
      <>
        {details && !this.state.showLoader ? (
          <DetailsCalculatorBridge {...calculatorBridgeProps}>
            <div className={`details-page-container ${isProgramMyElectric ? "white" : ""}`}>
                  <DetailsPageHelmet
                    pageType={this.state.pageType}
                    paramId={cutIdFromMathParams(this.props.match.params.id)}
                    details={details}
                    installment={this.state.calcCurrentPrices?.purePrice}
                  ></DetailsPageHelmet>
                  <SeoCarSchema {...buildSeoCarData(details, this.state.pageType, this.props.match.params.id)} />
                  <SeoBreadcrumbListSchema
                    make={details.Make}
                    model={details.Model}
                    pageType={this.state.pageType}
                    paramId={this.props.match.params.id}
                    currentPageName={
                      [
                        details.Make,
                        details.Model,
                        details.Type && replaceSpecialCharsets(details.Type)
                      ]
                        .filter(Boolean)
                        .join(" ")
                    }
                  />
                  <MobileSearchContext.Consumer>
                    {({ isMobileSearchOpen }) => {
                      return (
                        isMobileSearchOpen && (
                          <MobileMainPageSearch
                            avalibleMakesAndModels={this.props.avalibleMakesAndModels}
                            avalibleBodyTypes={this.props.avalibleBodyTypes}
                          />
                        )
                      );
                    }}
                  </MobileSearchContext.Consumer>
                  <div className={`background without-opacity default ${isWebpSupported ? "webp" : "no-webp"}`} />
                  <div className="mleasing-main-container">
                    <Breadcrumbs model={details.Model} make={details.Make} type={this.state.pageType} />
                  </div>
                  <div className="upper-container">
                    <div className="mleasing-main-container two-thirds-width witho">
                      <div className="content-wrapper">
                        <div className="left-wing mobile-padless">
                          <div className="basic-details-information-container">
                            <Media.DesktopOnly>
                              <DetailNavigationContainer
                                literals={this.state.literals}
                                returnToPreviousPage={this.returnToPreviousPage.bind(this)}
                                carId={details.AuctionId}
                                pageType={data.pageType}
                              />
                            </Media.DesktopOnly>
                            <span className="show-on-desktop direction-column">
                              <div className="basic-car-information-container title-container">
                                <Text
                                  as={isDesktopView ? "h1" : "h2"}
                                  styledAs="h1"
                                  color={FontColor.DARK}
                                  fontSize={FontSize.SIZE_40}
                                  lineHeight={LineHeight.HEIGHT_48}
                                >
                                  {`${details.Make} ${details.Model}`}
                                  {isDesktopView && seoTitleVersion && <span style={SEO_HIDDEN_STYLE}>{` ${seoTitleVersion}`}</span>}
                                </Text>
                              </div>
                              {this.state.pageType !== "new" && (
                                <div className="car-details-container">
                                  <div className="car-details-data">
                                    {details.Type && (
                                      <CarDetailsInformationTile
                                        icon={Car}
                                        text={replaceSpecialCharsets(details.Type)}
                                      />
                                    )}
                                    {details.FuelType && (
                                      <CarDetailsInformationTile icon={FuelPump} text={details.FuelType} />
                                    )}
                                    {details.PowerHP && (
                                      <CarDetailsInformationTile icon={Engine} text={`${details.PowerHP} KM`} />
                                    )}
                                    {details.GearBoxType && (
                                      <CarDetailsInformationTile icon={Gearbox} text={details.GearBoxType} />
                                    )}
                                    {details.PlateNumber && (
                                      <CarDetailsInformationTile icon={InfoRound} text={details.PlateNumber} />
                                    )}
                                  </div>
                                  <div className="car-details-tags">
                                    <Tag textColor={FontColor.LIGHT} backgroundColor="doveGrayUI">
                                      używany
                                    </Tag>
                                    {chips &&
                                      chips.map((label) => {
                                        return (
                                          <Tag key={uuid()} isBorder>
                                            {label.Text}
                                          </Tag>
                                        );
                                      })}
                                    {details.IsCertified && <Tag isBorder>certyfikowany</Tag>}
                                  </div>
                                </div>
                              )}

                              {this.state.pageType === "new" && (
                                <div className="car-details-container">
                                  <div className="car-details-data">
                                    {details.Type && (
                                      <CarDetailsInformationTile
                                        icon={Car}
                                        text={replaceSpecialCharsets(details.Type)}
                                      />
                                    )}
                                    {details.FuelType && (
                                      <CarDetailsInformationTile icon={FuelPump} text={details.FuelType} />
                                    )}
                                    {details.PowerHP && (
                                      <CarDetailsInformationTile icon={Engine} text={`${details.PowerHP} KM`} />
                                    )}
                                    {details.GearBoxType && (
                                      <CarDetailsInformationTile icon={Gearbox} text={details.GearBoxType} />
                                    )}
                                    {details.GearBoxType && (
                                      <CarDetailsInformationTile
                                        icon={Leaf}
                                        text={[details.Co2Emission, " CO", <sub>2</sub>]}
                                      />
                                    )}
                                  </div>
                                  <div className="car-details-tags">
                                    <Tag textColor={"zeusBlackUI"} backgroundColor={"confettiYellow"}>
                                      nowy
                                    </Tag>
                                    {chips &&
                                      chips.map((label) => {
                                        return (
                                          <Tag key={uuid()} isBorder>
                                            {label.Text}
                                          </Tag>
                                        );
                                      })}
                                    {details.IsCertified && <Tag isBorder>certyfikowany</Tag>}
                                  </div>
                                </div>
                              )}
                            </span>
                          </div>
                          <div>
                            <span className="basic-details-information-container show-on-mobile">
                              <div className="mobile-header">
                                <Text as={isDesktopView ? "h2" : "h1"} styledAs="h2" color={FontColor.DARK}>
                                  {`${details.Make} ${details.Model}`}
                                  {!isDesktopView && seoTitleVersion && <span style={SEO_HIDDEN_STYLE}>{` ${seoTitleVersion}`}</span>}
                                </Text>
                                <Text as="h4" color={"doveGrayUI"}>
                                  {replaceSpecialCharsets(details.Type)}
                                </Text>
                              </div>
                            </span>
                          </div>
                          {(details.Gallery360Link || details.Photos) && (
                            <>
                              <VehicleGallery
                                photos={
                                  this.state.pageType === "new"
                                    ? details.Gallery360Link && details.PhotosVC && details.PhotosVC.length
                                      ? [...details.PhotosVC.filter((el, i) => i > 7)]
                                      : details.Photos
                                    : details.Gallery360Link
                                    ? details.Photos?.filter((el, i) => i > 7)
                                    : details.Photos
                                }
                                isWebP={details.IsWebP}
                                returnFullsizeCarImage={(pic) => this.setBackgroundImage(pic)}
                                virtualGallerySRC={details.Gallery360Link}
                                checkIfShownSlider={this.checkIfShownSlider}
                                carDetails={this.state.details[0]}
                                pageType = {this.state.pageType}
                                TotalPriceBrutto={details.TotalPriceBrutto}
                                literals={this.state.literals}
                                urlToContactSection={this.state.urlToContactSection} 
                                handleContactModal={this.handleContactModal}
                              >
                                {!details.Reservation && details.SpecialPromotions && (
                                  <SpecialPromotions promotions={details.SpecialPromotions}></SpecialPromotions>
                                )}
                                <div
                                  className={`top-buttons ${
                                    this.state.isShowSlider ? "top-buttons--hide-left-border-radius" : ""
                                  }`}
                                >
                                  <ButtonCopyLink />
                                  <FavouriteButton carData={this.state.favouriteCarData} moduleType="DETAIL" />
                                </div>
                              </VehicleGallery>
                            </>
                          )}
                          <span className="basic-details-information-container show-on-mobile">
                            <Stack direction={Direction.COLUMN} spacing={8}>
                              {this.state.pageType !== "new" && (
                                <div className="notification-container">
                                  <Tag key={uuid()} backgroundColor="doveGrayUI">
                                    używany
                                  </Tag>
                                  {chips &&
                                    chips.map((label) => {
                                      return (
                                        <Tag key={uuid()} isBorder>
                                          {label.Text}
                                        </Tag>
                                      );
                                    })}
                                  {details.IsCertified && <Tag isBorder>certyfikowany</Tag>}
                                </div>
                              )}
                              {this.state.pageType === "new" && (
                                <Stack direction="row" spacing={8}>
                                  <Tag key={uuid()} backgroundColor="yellow30" textColor="zeusBlackUI">
                                    nowy
                                  </Tag>
                                  {chips &&
                                    chips.map((label) => {
                                      return (
                                        <Tag key={uuid()} isBorder>
                                          {label.Text}
                                        </Tag>
                                      );
                                    })}
                                  {details.IsCertified && <Tag isBorder>certyfikowany</Tag>}
                                </Stack>
                              )}
                              {this.state.pageType !== "new" && (
                                <div className="car-details-container">
                                  {details.Type && (
                                    <Media.DesktopOnly>
                                      <CarDetailsInformationTile
                                        icon={Car}
                                        text={replaceSpecialCharsets(details.Type)}
                                      />
                                    </Media.DesktopOnly>
                                  )}
                                  {details.FuelType && (
                                    <CarDetailsInformationTile icon={FuelPump} text={details.FuelType} />
                                  )}
                                  {details.PowerHP && (
                                    <CarDetailsInformationTile icon={Engine} text={`${details.PowerHP} KM`} />
                                  )}
                                  {details.GearBoxType && (
                                    <CarDetailsInformationTile
                                      icon={Gearbox}
                                      text={`${details.GearBoxType === "automatyczna" ? "automat" : "manual"}`}
                                    />
                                  )}
                                  {details.Co2Emission && (
                                    <CarDetailsInformationTile
                                      icon={Leaf}
                                      text={[details.Co2Emission, " CO", <sub>2</sub>]}
                                    />
                                  )}
                                  {details.PlateNumber && (
                                    <CarDetailsInformationTile icon={InfoRound} text={details.PlateNumber} />
                                  )}
                                </div>
                              )}

                              {this.state.pageType === "new" && (
                                <div className="car-details-container">
                                  {details.Type && (
                                    <Media.DesktopOnly>
                                      <CarDetailsInformationTile
                                        icon={Car}
                                        text={replaceSpecialCharsets(details.Type)}
                                      />
                                    </Media.DesktopOnly>
                                  )}
                                  {details.FuelType && (
                                    <CarDetailsInformationTile icon={FuelPump} text={details.FuelType} />
                                  )}
                                  {details.PowerHP && (
                                    <CarDetailsInformationTile icon={Engine} text={`${details.PowerHP} KM`} />
                                  )}
                                  {details.GearBoxType && (
                                    <CarDetailsInformationTile
                                      icon={Gearbox}
                                      text={`${details.GearBoxType === "automatyczna" ? "automat" : "manual"}`}
                                    />
                                  )}
                                  {details.Co2Emission && (
                                    <CarDetailsInformationTile
                                      icon={Leaf}
                                      text={[details.Co2Emission, " CO", <sub>2</sub>]}
                                    />
                                  )}
                                </div>
                              )}
                            </Stack>
                          </span>
                            {details.TotalPriceBrutto > 100000 && (
                              <div className="promo-banner-container--mobile">
                                <PromoBannerForAll isAfterLease={isAfterLease} literals={this.state.literals} urlToContactSection={this.state.urlToContactSection} handleContactModal={this.handleContactModal}/>
                              </div>
                            )}
                            {isAfterLease && details.TotalPriceBrutto <= 100000 && (
                              <div className="promo-banner-container--mobile">
                                <PromoBannerMB isAfterLease={isAfterLease} literals={this.state.literals} urlToContactSection={this.state.urlToContactSection} handleContactModal={this.handleContactModal}/>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`mleasing-main-container bg-transparent sticky one-third-width ${
                        this.state.pageType === "auction" ? "visible-in-struct" : ""
                      }`}
                    >
                      <div className="content-wrapper">
                        <div className="flex-end">
                        <CalculatorRework
                          pageType={this.state.pageType}
                          literals={this.state.literals}
                          carId={details.AuctionId}
                          reservation={details.Reservation}
                          availableAttracivenessLevels={this.state.availableAttracivenessLevels}
                          currentLevel={this.state.attractivenessLevel}
                          currentProvision={this.state.currentProvision}
                          levelChangeHandler={this.handelInterestLevelChange}
                          handleContactModal={this.handleContactModal}
                          setToggleRetailModalForm={this.setToggleRetailModalForm}
                          disableApplication={details.DisableApplication}
                          isProgramMyElectric={isProgramMyElectric}
                          isLeasingAvailable={details.IsLeasingAvailable}
                          isRentAvailable={details.IsRentAvailable}
                          isCashAvailable={details.IsCashAvailable}
                          totalPriceNetto={details.TotalPriceNetto}
                          totalPriceBrutto={details.TotalPriceBrutto}
                        />
                        </div>
                      </div>
                    </div>
                    <DetailsNavigation
                      isNewVehicle={isNewVehicle}
                      isCertified={details.IsCertified}
                      additionalEquipment={equipmentAdditional.length}
                      isSeoModel={isSeoModel}
                      modelNameForHeaders={modelNameForHeaders}
                    />
                    {isProgramMyElectric &&
                      this.state.literals &&
                      (this.state.literals?.silverbox_title || this.state.literals?.silverbox_text) && (
                        <div className="mleasing-main-container without-max-width my-electric-section">
                          <div className="content-wrapper">
                            <div className="wrapper">
                              {this.state.literals?.silverbox_title && (
                                <Text as="h2" marginBottom={24} className="my-electric-section__title">
                                  {this.state.literals.silverbox_title}
                                </Text>
                              )}
                              {this.state.literals?.silverbox_text && (
                                <Text as="p" marginBottom={32}>
                                  {this.state.literals.silverbox_text}
                                </Text>
                              )}
                              {this.state.literals?.silverbox_btn_link && this.state.literals?.silverbox_btn_title && (
                                <Link to={this.state.literals.silverbox_btn_link} target="_blank">
                                  <Button>{this.state.literals.silverbox_btn_title}</Button>
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="mleasing-main-container bg-white without-max-width">
                      <div className="content-wrapper">
                        <div className="left-wing">
                          <DetailsPageCalculatorMobileConnected
                            details={details}
                            pageType={this.state.pageType}
                            literals={this.state.literals}
                            setDarkMode={this.props.setDarkMode}
                            handleClickCalc={this.handleClickCalc}
                          />
                          <CharacteristicFeaturesList
                            title={`${isSeoModel?modelNameForHeaders:''}${this.state.literals && this.state.literals.prod_data}`}
                            list={data.technicalInformationList}
                            isTechnicalDataList
                            refEl={charListRef}
                            id="technicalInformation"
                          />
                          <div className={"availability-information-container"}>
                            {details.Location && (
                              <CharacteristicFeaturesList
                                disableShowMore={true}
                                list={
                                  !details.AvailableFrom
                                    ? [{ label: `miasto: ${details.Location}` }]
                                    : [
                                        { label: `miasto: ${details.Location}` },
                                        {
                                          label: `${
                                            details.AvailableFrom ? `dostępność: ${details.AvailableFrom}` : null
                                          }`
                                        }
                                      ]
                                }
                                title={
                                  this.state.literals &&
                                  (!details.AvailableFrom
                                    ? this.state.literals.prod_geo_hdr
                                    : `${this.state.literals.prod_geo_hdr} i dostępność`)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mleasing-main-container bg-gray without-max-width">
                      <div className="content-wrapper">
                        <div className="left-wing">
                          {!!equipment.length && (
                            <EquipmentList
                              title={`${isSeoModel?modelNameForHeaders:''}${
                                this.state.pageType === "new"
                                  ? this.state.literals && this.state.literals.prod_new_eqpmnt_hdr
                                  : this.state.literals && this.state.literals.prod_nused_eqpmnt_hdr
                              }`}
                              list={equipment}
                              id="standardEquipment"
                            />
                          )}
                          {this.state.pageType === "new" && !!equipmentAdditional.length && (
                            <EquipmentList
                              title={`${isSeoModel?modelNameForHeaders:''}${this.state.literals && this.state.literals.prod_new_addeqmnt_hdr}`}
                              list={equipmentAdditional}
                              id="additionalEquipment"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div id="certifiedDetailsContainer" className="mleasing-main-container bg-white without-max-width">
                      <div className="content-wrapper">
                        <div className="left-wing">
                          {details.IsCertified && (
                            <DetailsCertificateWidget
                              widgetUrl={details.Certificate.WidgetUrl}
                              onePageUrl={details.Certificate.OnePageUrl}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <DetailsPageCalculatorAdditionalPackagesConnected
                      pageType={this.state.pageType}
                      literals={this.state.literals}
                      isSeoModel={isSeoModel}
                      modelNameForHeaders={modelNameForHeaders}
                    />
                  </div>
                  <div className="lower-container">
                    <div className="mleasing-main-container bg-white without-max-width">
                      {isSeoModel && (
                        <div className="seo-section-container">
                          <div id="seo-section" className="seo-section content-wrapper" dangerouslySetInnerHTML={{ __html: seoModels[seoModelName]}}></div>
                        </div>
                      )}
                      <DetailWhyUs />
                      <CarAcquisitionSection/>
                      <AwardBanner whitebg/>
                      <CarsCarousel
                        carsType={"recommended"}
                        carsCount={this.state.recommendedCars.length}
                        carsList={this.state.recommendedCars}
                        changeHandler={() => this.handleCarouselOnChange()}
                        buttonText={data.pageType === "afterLease" ? "wszystkie auta używane" : "wszystkie auta nowe"}
                        buttonLink={data.pageType === "afterLease" ? "/samochody-poleasingowe" : "/nowe-samochody"}
                        sectionTitle={"samochody, które mogą Cię zainteresować"}
                        sectionDescription={""}
                        // theme="white"
                      />
                    </div>
                  </div>
                  {this.state.isContactModalOpen && this.state.urlObject && chips && (
                    <ContactModal
                      handleContactModal={this.handleContactModal}
                      urlObject={this.state.urlObject}
                      calcPrice={this.state.calculatorSnapshot?.selectedPrices}
                      pageType={data.pageType}
                      chips={chips}
                      calcCurrentPrices={this.state.calcCurrentPrices}
                      toggleRetailModalForm={this.state.toggleRetailModalForm}
                      handleCloseRequestModal={this.handleCloseRequestModal}
                      calculatorData={this.state.calculatorSnapshot?.calculatorData}
                      contactFormPayload={this.state.calculatorSnapshot?.contactFormPayload}
                    />
                  )}
                </div>
          </DetailsCalculatorBridge>
        ) : (
          <LoadingSpinner />
        )}
      </>
    );
  }
}

export default withRouter(DetailsPage);
